export const upSellProductsSlider = () => {
  const upSellProducts = document.getElementById("upsellSlider");
  if (upSellProducts) {
    const splide = new Splide(".splide--product-upsell", {
      type: "slide",
      perPage: 3,
      perMove: 1,
      drag: true,
      rewind: true,
      pagination: false,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 3,
        },
        1100: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }
};

export const relatedProductsSlider = () => {
  const relatedProducts = document.getElementById("relatedProducts");
  if (relatedProducts) {
    const splide = new Splide(".splide--related-products", {
      type: "slide",
      perPage: 3,
      perMove: 1,
      drag: true,
      rewind: true,
      pagination: false,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 3,
        },
        1100: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }
};

export const relatedPostsSlider = () => {
  const relatedPosts = document.querySelector(".splide-relatedPosts");
  if (!relatedPosts) return;

  const splide = new Splide(".splide-relatedPosts", {
    type: "slide",
    perPage: 3,
    perMove: 1,
    drag: true,
    rewind: true,
    pagination: false,
    gap: "24px",
    breakpoints: {
      1440: {
        gap: "24px",
        perPage: 3,
      },
      1100: {
        gap: "16px",
        perPage: 2,
      },
      576: {
        perPage: 1,
      },
    },
  });
  splide.mount();
};

export const partnersSlider = () => {
  const partners = document.querySelector(".splide-partners");
  if (!partners) return;

  const splide = new Splide(".splide-partners", {
    type: "slide",
    perPage: 5,
    perMove: 1,
    focus: "center",
    drag: true,
    arrows: false,
    pagination: true,
    gap: "32px",

    breakpoints: {
      1440: {
        perPage: 5,
        gap: "32px",
      },
      1100: {
        perPage: 4,
        gap: "24px",
      },
      768: {
        perPage: 3,
        gap: "20px",
      },
      576: {
        perPage: 2,
        gap: "16px",
      },
    },
  });

  splide.mount();
};

export const TeamSlider = () => {
  const sliders = document.querySelectorAll(".splide-team");
  if (!sliders.length) return;

  const instances = new WeakMap();

  const init = () => {
    const width = window.innerWidth;

    sliders.forEach((slider) => {
      const instance = instances.get(slider);

      if (width <= 992) {
        if (!instance) {
          const splide = new Splide(slider, {
            type: "slide",
            perPage: 2,
            perMove: 1,
            drag: true,
            pagination: false,
            arrows: false,
            gap: "32px",
            breakpoints: {
              992: {
                arrows: true,
              },
              576: {
                perPage: 1,
                gap: "16px",
              },
            },
          });

          splide.mount();
          instances.set(slider, splide);
        }
      } else {
        if (instance) {
          instance.destroy(true);
          instances.delete(slider);
        }
      }
    });
  };

  init();
  window.addEventListener("resize", init);
};
